<template>
  <div id="userLayout" class="dk-login-layout">
    <main class="dk-login-shell">
      <section class="dk-login-visual" aria-label="数字化智能中台系统">
        <img src="~@/assets/dkmall/login-left.png" alt="数字化智能中台系统">
      </section>
      <section class="dk-login-panel">
        <router-view />
        <footer class="dk-login-footer">
          <div class="service-phone">
            <img src="~@/assets/dkmall/login-phone.png" alt="客服电话">
            <span>11233423423</span>
          </div>
          <div class="copyright">
            Copyright©2026 Copyright ©2024 中犇科技 All rights reserved. 备案号：
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">豫ICP备2021028802号</a>
          </div>
        </footer>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'UserLayout',
  mounted () {
    document.title = 'DK商城'
    document.body.classList.add('userLayout')
  },
  beforeDestroy () {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="less" scoped>
.dk-login-layout {
  min-height: 100vh;
  background: #f7f8fc;
  color: #333;
}

.dk-login-shell {
  min-height: 100vh;
  display: flex;
}

.dk-login-visual,
.dk-login-panel {
  width: 50%;
  min-height: 100vh;
}

.dk-login-visual {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;

  img {
    width: 92%;
    max-width: 720px;
    height: auto;
    display: block;
  }
}

.dk-login-panel {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #fff;
  padding: 48px 64px 132px;
}

.dk-login-footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 34px;
  color: #999;
  text-align: center;
  font-size: 13px;

  .copyright {
    white-space: nowrap;
  }

  .service-phone {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    color: #333;
    font-size: 16px;

    img {
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }
  }

  a {
    color: #999;
  }
}

@media (max-width: 991px) {
  .dk-login-visual {
    display: none;
  }

  .dk-login-panel {
    width: 100%;
    padding: 36px 24px 130px;
  }

  .dk-login-footer {
    left: 16px;
    right: 16px;
    font-size: 12px;

    .copyright {
      white-space: normal;
    }
  }
}
</style>
